<template>
    <div>
        <div>
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
                工资申请单-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
            <el-button
                style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                @click="Return">返回</el-button>

            <!-- 主体 -->
            <div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
                <!-- 查询框 -->
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="类别" prop="dictionaries_id" style="margin-top:80px;width:80%">
                                <el-select v-model="ruleForm.dictionaries_id" style="width:595px" placeholder="请选择"
                                    clearable>
                                    <el-option v-for="item in $parent.dictionariesList" :key="item.id"
                                        :label="item.data" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <div @click="StaffFind">
								<el-form-item label="姓名" prop="staff_name" style="width:80%">
								    <el-input style="width:595px" v-model="ruleForm.staff_name"  onfocus="this.blur();">
								    </el-input>
								</el-form-item>
                            </div>
                            
                            <!-- <el-form-item label="姓名" prop="staff_id">
                                <el-select v-model="ruleForm.staff_id" style="width:595px" placeholder="请选择" filterable
                                    clearable @change="selectStaff">
                                    <el-option v-for="item in staffList" :key="item.id" :label="item.staff_name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                        </el-col>
                    </el-row>
					
					<el-row>
					    <el-col :span="12">
					        <el-form-item label="项目">
					            <el-input v-model="ruleForm.project_name" style="width:595px">
					            </el-input>
					        </el-form-item>
					    </el-col>
					</el-row>
                    <!-- <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="staff_name" style="width:80%">
                                <el-input style="width:595px" v-model="ruleForm.staff_name" onfocus="this.blur();">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="职位">
                                <el-input v-model="ruleForm.post_name" :disabled="true" style="width:595px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row> -->

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="时间" prop="current_date">
                                <el-date-picker v-model="ruleForm.current_date" style="width:595px" type="date"
                                    value-format="yyyy-MM-dd" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="原因" prop="reason">
                                <el-input type="textarea" :rows="2" style="width:595px" placeholder="请输入奖励/处罚原因"
                                    v-model="ruleForm.reason">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="金额" prop="money" style="width:80%">
                                <el-input type="number" v-model="ruleForm.money" placeholder="请输入奖励/处罚金额" 
                                    style="width:595px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                    <el-form-item style="margin-left:200px">
                        <el-button type="goon" @click="add()"
                            v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
                        <el-button type="goon" @click="UpdateAuditor()"
                            v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
                        <el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>

            </div>
        </div>

        <!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
            :close-on-click-modal="false">
            <SelectAuditor ref="SelectAuditor" :type="10" :examineDetailsList="ruleForm.examineDetailsList"
                :id="ruleForm.id"></SelectAuditor>
        </el-dialog> -->
        <el-dialog title="选择姓名" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<!-- <organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
					:staff_id_prop="ruleForm.staff_id"></organizeStaff> -->
					<organizeStaff ref="organizeStaff" type="checkbox" :accordion="true"
					    @commit="saveChange"
					    :staff_ids_prop="ruleForm.staff_ids"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

    </div>
</template>

<script>
    // import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
    import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
    export default {
        components: {
            // SelectAuditor: SelectAuditor,
            organizeStaff: organizeStaff,
        },
        data() {
            return {

                //表单数据
                ruleForm: {
                    id: '',
                    dictionaries_id: '',
                    staff_id: '',
                    staff_name:'',
                    project_id: '',
                    project_name: '',
                    post_id: '',
                    post_name: '',
                    current_date: '',
                    reason: '',
                    money: '',
                    examineDetailsList: [],
					staff_ids:[],
                },

                //表单验证
                // rules: {
                //     dictionaries_id: [{
                //         required: true,
                //         message: '请选择类别！',
                //         trigger: 'blur'
                //     }],
                //     staff_name: [{
                //         required: true,
                //         message: '请选择员工！',
                //         trigger: 'blur'
                //     }],
                //     current_date: [{
                //         required: true,
                //         message: '请选择时间！',
                //         trigger: 'blur'
                //     }],
                //     money: [{
                //         required: true,
                //         message: '请输入奖励/处罚金额！',
                //         trigger: 'blur'
                //     }],
                // },

                //数据
                staffList: [],
				supportStaffList:[],
                //页面相关
                dialogAuditorVisible: false,
                dialogVisible:false
            };
        },
        methods: {
            //获取
            StaffFind() {
                this.dialogVisible = true;
                // this.staffList.forEach(item => {
                //     if (item.id === this.ruleForm.staff_id) {
                //         this.ruleForm.post_id = item.post_id;
                //         this.ruleForm.post_name = item.post_name;
                //         this.ruleForm.project_name = item.organize_name;
                //         this.ruleForm.project_id = item.project_id;
                //     }
                // })
            },
            //设置确定
			saveChange(e) {
				var change_staff = "";
				e.staff_ids.forEach(item => {
					change_staff += item + ",";
				})
				this.ruleForm.staff_id = change_staff;
				this.ruleForm.staff_name = e.staff_name;
				this.supportStaffList = this.ruleForm.staff_id.split(",");
				this.supportStaffList = this.supportStaffList.splice(0,this.supportStaffList.length-1);
                this.ruleForm.project_name = e.organize_name;
                this.ruleForm.post_name = e.staff[0].post_name;
                this.dialogVisible = false;
			},
            //获取职位和部门
            // selectStaff() {
            //     this.staffList.forEach(item => {
            //         if (item.id === this.ruleForm.staff_id) {
            //             this.ruleForm.post_id = item.post_id;
            //             this.ruleForm.post_name = item.post_name;
            //             this.ruleForm.project_name = item.organize_name;
            //             this.ruleForm.project_id = item.project_id;
            //         }
            //     })
            // },
            //添加
            // AddAuditor() {
            //     this.$refs["ruleForm"].validate((valid) => {
            //         if (valid) {
            //             this.Add()
            //         } else {
            //             console.log('error submit!!');
            //             return false;
            //         }
            //     });
            // },
            async add() {
				this.supportStaffList = [];
                if(this.ruleForm.dictionaries_id == null || this.ruleForm.dictionaries_id == ''){
                    this.$message.error('请选择类别！');
                }else if(this.ruleForm.staff_name == null || this.ruleForm.staff_name == ''){
                    this.$message.error('请选择姓名！');
                }else if(this.ruleForm.current_date == null || this.ruleForm.current_date == ''){
                    this.$message.error('请选择时间！');
                }else if(this.ruleForm.money == null || this.ruleForm.money == ''){
                    this.$message.error('请输入奖励/处罚金额');
                }else if(this.ruleForm.reason == null || this.ruleForm.reason == ''){
					this.$message.error('请输入奖励/处罚原因');
				}else{
                    var url = 'bonusPenalty/add';
                    var record = {
                        dictionaries_id: this.ruleForm.dictionaries_id,
                        staff_ids: this.supportStaffList,
                        project_id: this.ruleForm.project_id,
                        post_id: this.ruleForm.post_id,
                        current_date: this.ruleForm.current_date,
                        reason: this.ruleForm.reason,
                        money: this.ruleForm.money,
                        examineDetailsList: this.ruleForm.examineDetailsList,
                        applicant_id: this.$globals.user.staff_id,
                    };
                    var data = await this.$globals.AxiosPost(url, record);
                    if (data === '-2000') {
                        this.$message.error('服务器未响应！请稍后重试');
                    }else {
                        var code = data.code;
                        var data = data.data;
                        if (code === '200') {
                            this.$message.success(data);
                            this.Return();
                        } else {
                            this.$message.warning(data);
                        }
                    }
                } 
            },
            //修改
            // UpdateAuditor() {
            //     this.$refs["ruleForm"].validate((valid) => {
            //         if (valid) {
            //             this.ruleForm.examineDetailsList = [];
            //             this.dialogAuditorVisible = true;
            //             this.$refs['SelectAuditor'].initialize();
            //         } else {
            //             console.log('error submit!!');
            //             return false;
            //         }
            //     });
            // },
            async UpdateAuditor() {
				this.supportStaffList = [];
                var url = 'bonusPenalty/modify';
                var record = {
                    id: this.ruleForm.id,
                    dictionaries_id: this.ruleForm.dictionaries_id,
                    staff_ids: this.supportStaffList,
                    project_id: this.ruleForm.project_id,
                    post_id: this.ruleForm.post_id,
                    current_date: this.ruleForm.current_date,
                    reason: this.ruleForm.reason,
                    money: this.ruleForm.money,
                    examineDetailsList: this.ruleForm.examineDetailsList,
                    applicant_id: this.$globals.user.staff_id,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            Return() {
                this.dialogAuditorVisible = false;
                this.$parent.Return();
            }
        },
        async created() {
            // 员工
            var staffList = await this.$globals.AxiosPost("staff/selectFind", {});
            this.staffList = staffList.data;

            this.ruleForm = this.$parent.ruleForm;
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Jcgl_add.vue?67db8499